import { render, staticRenderFns } from "./AdditionalInfoComponent.vue?vue&type=template&id=5fa5b5e1"
import script from "./AdditionalInfoComponent.vue?vue&type=script&lang=js"
export * from "./AdditionalInfoComponent.vue?vue&type=script&lang=js"
import style0 from "./AdditionalInfoComponent.vue?vue&type=style&index=0&id=5fa5b5e1&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports